export enum SubscriptionTabsEnum {
  POSITIONS = 'positions',
  DURATION = 'duration',
  BILLING_INFORMATION = 'billing-information',
  PREFERENCES = 'preferences',
  DOCUMENTS = 'documents',
}
